module.exports = __webpack_public_path__ + "static/media/material-silk.59a488f5.svg";